import UpcEditor from "../symbols/upcEditor";

const upcEditorSymbolsSetSelectedTabAction = (selected: number) => ({
  type: UpcEditor.SET_SELECTED_TAB,
  payload: selected,
});

export function setSelectedUpcEditorTab(selected: number) {
  return (dispatch: any) => {
    dispatch(upcEditorSymbolsSetSelectedTabAction(selected));
  };
}
